export default __webpack_public_path__ + "static/media/015-pet shop.ade0fdc2.svg";